import { __decorate } from "tslib";
import { AsnProp, AsnPropTypes } from "@peculiar/asn1-schema";
export var LogotypeAudioChannels;
(function (LogotypeAudioChannels) {
    LogotypeAudioChannels[LogotypeAudioChannels["mono"] = 1] = "mono";
    LogotypeAudioChannels[LogotypeAudioChannels["stereo"] = 2] = "stereo";
    LogotypeAudioChannels[LogotypeAudioChannels["quad"] = 4] = "quad";
})(LogotypeAudioChannels || (LogotypeAudioChannels = {}));
export class LogotypeAudioInfo {
    constructor(params = {}) {
        this.fileSize = 0;
        this.playTime = 0;
        this.channels = LogotypeAudioChannels.mono;
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], LogotypeAudioInfo.prototype, "fileSize", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], LogotypeAudioInfo.prototype, "playTime", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], LogotypeAudioInfo.prototype, "channels", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Integer, implicit: true, context: 3, optional: true })
], LogotypeAudioInfo.prototype, "sampleRate", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.IA5String, implicit: true, context: 4, optional: true })
], LogotypeAudioInfo.prototype, "language", void 0);
